const phoneMask = () => {
  return [
    "(",
    /\d/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/
  ];
};

export default phoneMask;



// WEBPACK FOOTER //
// ./src/components/Masks/Phone.js